import React from "react";
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { useTranslations } from '../../../locales/useTranslations';

const MetabaseVerständnisundErfahrungfürIhreBranche = () => {
    const { t } = useTranslations();
    return (
        <section className="ptb-100 metabase-experience">
            {/* Dekorative Hintergrund-Elemente */}
            <div className="metabase-experience__decoration metabase-experience__decoration--top-right"></div>
            <div className="metabase-experience__decoration metabase-experience__decoration--bottom-left"></div>

            <div className="container pb-35 metabase-experience__container">
                <div className="about-content text-center">
                    <span className="metabase-experience__badge">
                        {t("metabase_verständnisundErfahrungfürIhreBranche_subTitle")}
                    </span>
                    <h2 className="metabase-experience__title">
                        {t("metabase_verständnisundErfahrungfürIhreBranche_title")}
                    </h2>
                    <p className="metabase-experience__description">
                        {t("metabase_verständnisundErfahrungfürIhreBranche_description")}
                    </p>
                </div>
            </div>

            <div className="overview-item metabase-experience__container">
                <div className="container max-width-600">
                    <div className="native-accordion metabase-experience__accordion">
                        <details>
                            <summary>
                                {t("metabase_verständnisundErfahrungfürIhreBranche_question1")}
                            </summary>
                            <div className="metabase-experience__answer-container">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <p className="metabase-experience__answer-text">
                                                {t("metabase_verständnisundErfahrungfürIhreBranche_answer1")}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </details>

                        <details>
                            <summary>
                                {t("metabase_verständnisundErfahrungfürIhreBranche_question2")}
                            </summary>
                            <div className="metabase-experience__answer-container">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <p className="metabase-experience__answer-text">
                                                {t("metabase_verständnisundErfahrungfürIhreBranche_answer2")}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </details>

                        <details>
                            <summary>
                                {t("metabase_verständnisundErfahrungfürIhreBranche_question3")}
                            </summary>
                            <div className="metabase-experience__answer-container">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <p className="metabase-experience__answer-text">
                                                {t("metabase_verständnisundErfahrungfürIhreBranche_answer3")}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </details>

                        <details>
                            <summary>
                                {t("metabase_verständnisundErfahrungfürIhreBranche_question4")}
                            </summary>
                            <div className="metabase-experience__answer-container">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <p className="metabase-experience__answer-text">
                                                {t("metabase_verständnisundErfahrungfürIhreBranche_answer4")}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </details>

                        <details>
                            <summary>
                                {t("metabase_verständnisundErfahrungfürIhreBranche_question5")}
                            </summary>
                            <div className="metabase-experience__answer-container">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <p className="metabase-experience__answer-text">
                                                {t("metabase_verständnisundErfahrungfürIhreBranche_answer5")}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </details>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default MetabaseVerständnisundErfahrungfürIhreBranche;
